import Vue from 'vue'
import Vuex from 'vuex'
import { authActions, authMutations, authState } from './auth'
import configs from './configs'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    load: false,
    ...authState,

    atendimentos: {
      status: false,
      total: 0
    },

    progressDisparo: 0,
    modalOflline: false,

    update: {
      title: '',
      mensagem: '',
      step: 0,
      progress: 0
    }
  },

  mutations: {
    ...authMutations,

    SET_PROGRESS_DISPARO(state, progress) {
      state.progressDisparo = progress;
    },

    SET_MODAL_OFFLINE(state, status) {
      state.modalOflline = status;
    },

    SET_UPDATE_REPLY(state, payload) {
      state.update.title = payload.message;
      state.update.mensagem = payload.detail;
      state.update.step = payload.step;
    },

    SET_UPDATE_PROGRESS(state, progress) {
      state.update.progress = progress;
    }
  },

  actions: {
    ...authActions,
  },

  modules: {
    configs,
  }
})
